import { Component, Input, Output, EventEmitter, HostListener, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
    selector: 'app-custom-dropdown',
    templateUrl: './custom-dropdown.component.html',
    styleUrls: ['./custom-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule],
    animations: [
        trigger('slideDown', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(-8px)' }),
                animate('150ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
            ]),
            transition(':leave', [
                animate('150ms ease-in', style({ opacity: 0, transform: 'translateY(-8px)' }))
            ])
        ])
    ]
})
export class CustomDropdownComponent {
    @Input() options: string[] = [];
    @Input() value: string = '';
    @Input() placeholder: string = '-- Select --';
    @Input() disabled: boolean = false;
    @Input() label: string = '';
    @Input() loading: boolean = false;
    @Output() selectionChange = new EventEmitter<string>();

    @ViewChild('dropdownTrigger') dropdownTrigger!: ElementRef;

    isOpen: boolean = false;

    constructor(private elementRef: ElementRef) {}

    toggleDropdown(): void {
        if (!this.disabled) {
            this.isOpen = !this.isOpen;
        }
    }

    closeDropdown(): void {
        this.isOpen = false;
    }

    selectOption(option: string): void {
        if (!this.disabled) {
            this.value = option;
            this.selectionChange.emit(option);
            this.closeDropdown();
        }
    }

    getDisplayValue(): string {
        return this.value || this.placeholder;
    }

    isOptionSelected(option: string): boolean {
        // Case-insensitive matching for exact match
        return option.toLocaleLowerCase().trim() === this.value.toLocaleLowerCase().trim();
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.closeDropdown();
        }
    }
}
